import React from "react";
import { View } from "react-native";
import colors from "@constants/color";
import Text from "@components/CustomText";

import t from "@constants/localization";

const PATH = "screens/SupportTree/components/Label";

const Label = ({ label, type }) => (
  <View style={{ marginVertical: 10, flexDirection: "row" }}>
    <Text
      variant="subtitle_16"
      style={{
        color: colors.mediumBlack,
      }}
    >
      {label}
    </Text>
    {type && type === "images" && (
      <Text variant="body_text_3" style={{ color: colors.lightBlack }}>
        {t(`${PATH}/maximumPhotos`)}
      </Text>
    )}
  </View>
);

export default Label;
